export const environment = {
    tokenName: 'authToken',
    debug: true,
    production: false,
    userData: 'userData',
    api: "https://api.barbaraminto.com/v1",
    //api: "http://localhost:5002/v1",
    videosUrl: "/videos/",
    //videosUrl: 'https://course.barbaraminto.com/assets/videos/'
}; 


// WEBPACK FOOTER //
// ./client/app/services/environment.js